import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postTravelFiveSlice = createSlice({
  name: "postTravelFive",
  initialState,
  reducers: {
    postTravelFiveStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postTravelFiveSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postTravelFiveFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postTravelFiveStart,
  postTravelFiveSuccess,
  postTravelFiveFailure,
  clearError,
  clearMessage,
} = postTravelFiveSlice.actions;

export default postTravelFiveSlice.reducer;
